cockpitApp.directive('segment', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/journey/segment'
  };
});
